/**
 * Waits for elements matching a given query selector, according to behavior defined in options.
 *
 * The elements found are returned as an array.
 *
 * @param { string } selector The DOM selector for the desired elements
 * @param { Object } options
 * @param { number } options.max_attempts Max number of attempts to make when trying to select
 * @param { number } options.interval_ms Wait time between attempts
 * @param { number } options.expected_count The number of elements expected, will continue attempts until `max_attempts` if not found
 *
 * @return { HTMLElement[] }
 */
export const waitForElements = async (selector, options) => {
  options = {
    max_attempts: 20,
    interval_ms: 100,
    expected_count: 1,
    ...options,
  };

  let attempt = 0;
  let els = new Set([]);
  while (attempt < options.max_attempts) {
    els = new Set([
      ...els,
      ...[...document.querySelectorAll(selector)],
    ]);
    if (els.size >= options.expected_count) break;
    else attempt += 1;

    await new Promise(res => setTimeout(res, options.interval_ms));
  }
  return [...els];
};

/**
 * Convert a css length into pixel count, as displayed on the user's browser.
 *
 * @param { string } value
 * @returns { number }
 */
export const cssUnitsToPixels = (value) => {
  const dummy_el = document.createElement('div');
  document.body.appendChild(dummy_el);
  dummy_el.style.visibility = 'hidden';

  dummy_el.style.width = value;

  const resolved_pixel_size = dummy_el.clientWidth;

  dummy_el.remove();

  return resolved_pixel_size;
};
